
































import { listFactory } from '@/main/pages';
import { openEdit } from '@/main/router/routerPath';
import { PageMode } from '@/main/utils/pageMode';
import { NAME } from './constants';
import { store } from './store/list';
import { apiProvider } from './api';
import { formatDate, formatDateTime,formatMonthYear } from '@/main/utils/dateFormatter';
import { isMultipleWorkshopSelected, getSearchButtonLabel, handleMultiWorkshopFilter, validateDateFields, getCurrentLanguageId } from '@/main/utils/commonFunctions';
import moment from 'moment';
import { getColumnsNames } from '@/main/utils/table';
export default listFactory(NAME, store).extend({
	data() {
		return {
			validateMessage: '',
		}
	},
	computed: {
		isMultipleWorkshopSelected(): boolean {
			return isMultipleWorkshopSelected(this.WorkshopId);
		},
		searchButtonLabelKey(): string {
			return getSearchButtonLabel(this.WorkshopId);
		},
	},
	watch: {
	MonthYear: {
		immediate: true,
		async handler(value, oldVal) {
			if (value) {
				// this.MonthYear = this.MonthYear ? formatDate(this.MonthYear.toLocaleString()) : this.MonthYear;
				// this.Month = moment(this.MonthYear).month()+1;
				// this.Year = moment(this.MonthYear).year();
			}
		},
	},
},
	methods:{	
			async filterClick() {
				if((this.WareHouseId===null||this.WareHouseId===0)&&this.WorkshopId.length===1){
				this.showErrorAlert({ message: this.LocalizePopisPoli('WARE_HOUSE_REQUIRED') });
				return;
			}
			if (!this.DateFrom) {
				this.showErrorAlert({ message: this.LocalizePopisPoli('DP_DATEFROM_VALIDATION') });
				return;
			}
			if (!this.DateTo) {
				this.showErrorAlert({ message: this.LocalizePopisPoli('DP_DATETO_VALIDATION') });
				return;
			}
			await handleMultiWorkshopFilter(
				this,
				NAME,
				this.WorkshopId,
				(columnsSeq) => ({
					DateFrom: formatDate(new Date(this.DateFrom!).toISOString()),
					DateTo: formatDate(new Date(this.DateTo!).toISOString()),
					PracovnikId: this.loggedUser.PracovnikData.PracovnikId,
					WareHouseId: 0,
					WorkshopId: this.WorkshopId,
					LanguageId: getCurrentLanguageId(this.loggedUser.UzivatelData.LanguageId),
					AllItems: this.AllItems,
				}),
			);
		},
		async onWorkShopChange(workshopId: any) {
				if (workshopId !== undefined) {
					const { data } = await apiProvider.GetWarehouse(workshopId);
					this.dropdownList.WareHouseId = data;
					this.WareHouseId=0;
				}
		},
		
		wareHouseUpdate() {
		
			const result = {} as any;
			this.dropdownList.WareHouseId.forEach((o: any) => {
				result[o.Value] = o.Text;
			});
		},

		dateValidation() {
			if (this.DateFrom && this.DateTo) {
				const fromDate = new Date(this.DateFrom);
				const toDate = new Date(this.DateTo);
				if (fromDate > toDate) {
					this.showErrorAlert({ message: this.LocalizePopisPoli('DP_FROM_DATE_LESS_THAN_TO_DATE') });
					this.DateFrom = null;
					this.DateTo = null;
					return false;
				}
				const milisecondPerDay = 1000 * 60 * 60 * 24;

				const utc1 = Date.UTC(fromDate.getFullYear(), fromDate.getMonth(), fromDate.getDate());
				const utc2 = Date.UTC(toDate.getFullYear(), toDate.getMonth(), toDate.getDate());
				const dayDifference = Math.floor((utc2 - utc1) / milisecondPerDay);
				if (dayDifference > 365) {
					this.showErrorAlert({ message: this.LocalizePopisPoli('DP_365_DAY_DIFF') });
					this.DateFrom = null;
					this.DateTo = null;
					return false;
				}
				return true;
			}
			return false;
		},

		async exportFun() {
			try {
				if (this.filter.WorkshopId == null || this.filter.WorkshopId.length === 0) {
					this.showErrorAlert({ message: this.LocalizePopisPoli('DEALER_CODE_NOT_NULL') });
					return;
				}
				if (!this.filter.DateFrom || !this.filter.DateTo) {
					this.showErrorAlert({ message: this.LocalizePopisPoli('CR_DATE_VALIDATION') });
					return;
				}
				if (this.filter.WorkshopId.length === 1 && (this.WareHouseId == null || this.WareHouseId === 0)) {
					this.showErrorAlert({
						message: this.LocalizeChyboveHlasky('WareHouseIdCanNotBeNull'),
						options: { type: 'error' },
						localizeMessage: false,
					});
				} else {
					const getColumnsSequence = getColumnsNames(this.table.columns.filter(x => x.isVisible === true));
					this.startLoading();
					let parameters = '';
					if (this.WorkshopId.length > 0) {
						this.WorkshopId.forEach((WorkshopId: any) => {
							parameters = parameters.concat(`&WorkshopId=${WorkshopId}`);
						});
					}
					if (this.isMultipleWorkshopSelected) {
						this.showErrorAlert({
							message: this.LocalizeChyboveHlasky('MultiWorkshopExportDisabled'),
						});
					} else {
						await apiProvider.GetFullStockValueMovementReport(formatDate(new Date(this.DateFrom!)
							.toISOString()), formatDate(new Date(this.DateTo!).toISOString()), parameters, getCurrentLanguageId(this.loggedUser.UzivatelData.LanguageId), this.WareHouseId ?? 0,this.AllItems);
					}
					this.endLoading();
				}
			} catch (error) {
				this.endLoading();
			}
		}
	},

	mounted(){
		var element = document.getElementsByClassName("el-main");
					if(element.length!=0)
						element[0].classList.remove('d-flex');
		}
});
